import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MembersService } from 'src/app/shared/services/members.service';

@Injectable({
  providedIn: 'root'
})
export class SecureLinkGuardService {
  constructor(
    private router: Router,
    private membersService: MembersService
  ) {}

  canUseSecureLink(personId: string, secureLinkId: string, target: string): Observable<boolean> {
    var obs = this.membersService.canUseSecureLink(personId, secureLinkId);

    obs.subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl(target);
      }
    });

    return obs;
  }

  canUseAnonymousSecureLink(secureLinkId: string, target: string): Observable<boolean> {
    var obs = this.membersService.canUseAnonymousSecureLink(secureLinkId);

    obs.subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl(target);
      }
    });

    return obs;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const target = route.data.target ?? '/home';
    return route.params.personId
      ? this.canUseSecureLink(route.params.personId, route.params.secureLinkId, target)
      : this.canUseAnonymousSecureLink(route.params.secureLinkId, target);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
